import { Link, LinkProps } from '@chakra-ui/react';
import { FC } from 'react';
import { LinkConnector } from '../LinkConnector';
import { formatAddress } from '@onbeam/utils';

type WalletLinkProps = LinkProps & {
  walletAddress: string;
  userAddress?: string;
  username?: string | null;
  href: string;
};

export const WalletLink: FC<WalletLinkProps> = ({
  userAddress,
  walletAddress,
  username,
  href,
  ...props
}) => (
  <LinkConnector href={href}>
    <Link
      borderBottom="1px dashed"
      textDecoration="none"
      overflow={{ lg: 'hidden' }}
      whiteSpace={{ lg: 'nowrap' }}
      textOverflow={{ lg: 'ellipsis' }}
      {...props}
    >
      {userAddress && userAddress.toLowerCase() === walletAddress.toLowerCase()
        ? 'You'
        : username || formatAddress(walletAddress)}
    </Link>
  </LinkConnector>
);
